export const labels = ["Bản tiếng việt", "Bản tiếng anh"];
